import {useSelector} from 'react-redux';
import {RootState} from '../store/store';

export default function useApiKeyCreationLock():string|null {
    const forecast=useSelector((state:RootState)=>state.billingForecast.forecast);
    const status=useSelector((state:RootState)=>state.billingForecast.status);
    // A forecast that failed to load leaves the decision to the server (POST /v1/auth/keys answers 403 when no card).
    if (!forecast) return status==='failed' ? null : 'Checking API-key access…';
    return forecast.policy_version===3 && forecast.tier!=='carded'
        ? 'Connect a card to create API keys.' : null;
}
